import { useState } from 'react';
import HeroSection from './components/HeroSection';
import ShopByOccasion from './components/ShopByOccasion';
import ShopByStyle from './components/ShopByStyle';
import Bestsellers from './components/Bestsellers';
import WhyJoviaa from './components/WhyJoviaa';
import DurabilityProof from './components/DurabilityProof';
import PackagingTeaser from './components/PackagingTeaser';
import InstagramUGC from './components/InstagramUGC';
import NewsletterBand from './components/NewsletterBand';
import PullToRefresh from '@/components/base/PullToRefresh';

export default function Home() {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = async () => {
    await new Promise((resolve) => setTimeout(resolve, 600));
    setRefreshKey((k) => k + 1);
  };

  return (
    <main>
      <PullToRefresh onRefresh={handleRefresh}>
        <div key={refreshKey}>
          <HeroSection />
          <ShopByOccasion />
          <ShopByStyle />
          <Bestsellers />
          <WhyJoviaa />
          <DurabilityProof />
          <PackagingTeaser />
          <InstagramUGC />
          <NewsletterBand />
        </div>
      </PullToRefresh>
    </main>
  );
}